const tipLink = "https://buy.stripe.com/00w3cw8Xc7lV0qG6uQ4sE00";

export { tipLink };
